import { TFunction } from "i18next";
import { BoundedName } from "@pulse/pulse-rpcs/lib/types/boundedName";
import { EmailTemplateContentValidationErrorEnum } from "../../emailTemplates/enums/EmailTemplateContentValidationErrorEnum";

export interface EmailCycleMessageCustomizationValidationError {
  body: EmailTemplateContentValidationErrorEnum | undefined;
}

export const getBodyValidationErrorMessage = (
  t: TFunction,
  validationError: EmailTemplateContentValidationErrorEnum,
): string => {
  switch (validationError) {
    case EmailTemplateContentValidationErrorEnum.MinSize:
      return t("emailCycles.bodyMinSizeErrorMessage");
    case EmailTemplateContentValidationErrorEnum.MaxSize:
      return t("emailCycles.bodyMaxSizeErrorMessages", {
        maxSize: BoundedName.constraints.name.maxSize,
      });
    default:
      return validationError satisfies never;
  }
};

export const getEmailCycleMessageCustomizationValidationErrorMessage = (
  t: TFunction,
  validationErrors: EmailCycleMessageCustomizationValidationError,
): Record<
  keyof EmailCycleMessageCustomizationValidationError,
  string | undefined
> => ({
  body: validationErrors.body
    ? getBodyValidationErrorMessage(t, validationErrors.body)
    : undefined,
});
